import { useAuthQuery } from '../auth'
import { ApiAgentRequest, request } from '../../utils/request'
import { ApplicationsPageProps } from './types'

type RawApplicationsListPagePropsResponse = {
  data: ApplicationsPageProps
}

export function useGetApplicationsListPageProps() {
  const { data, isLoading, isFetching } = useAuthQuery(
    ['page-props', { page: 'applications'}],
    async () => {
      return await request<RawApplicationsListPagePropsResponse>(
        new ApiAgentRequest(`/applications/page-props`, {
          method: 'GET',
        }),
        {
          isExpectedResponse: (res): res is RawApplicationsListPagePropsResponse => res as boolean,
        },
      )
    },
    {
      enabled: true,
    },
  )

  return {
    isLoadingApplications: isLoading,
    isFetchingApplications: isFetching,
    pageProps: data?.data || null,
  }
}
